module.exports = __webpack_public_path__ + "static/img/logo-abav.9b848b5a.png";